import Vue from 'vue'
import App from './App.vue'
import { router } from '@/router'
import store from './store'
import Vuelidate from 'vuelidate'
import VueGtag from 'vue-gtag'
import VueSocketIO from 'vue-socket.io'

import HelpModal from './components/Modals/HelpModal.vue'
import DestinationModal from './components/Modals/DestinationModal.vue'
import FamilyDiscModal from './components/Modals/FamilyDiscModal.vue'
import WinterSportsModal from './components/Modals/WinterSportsModal.vue'
import CruiseModal from './components/Modals/CruiseModal.vue'
import CarModal from './components/Modals/CarModal.vue'
import Discount25Modal from './components/Modals/Discount25Modal.vue'
import AdventureModal from './components/Modals/AdventureModal.vue'
import GroupIns from './components/Modals/GroupIns.vue'
import ProgessBar from './components/ProgressBar.vue'
import AnnualPolicyModal from '@/components/Modals/AnnualTripPolicy'
import BackPackerMedicalModal from '@/components/Modals/BackpackerMedicalModal'

const { VUE_APP_SOCKET_API } = process.env

Vue.use(Vuelidate)
Vue.use(
  new VueSocketIO({
    debug: false,
    connection: VUE_APP_SOCKET_API,
    options: { path: '/so-api/barclay/socket' }
  })
)

const isIE = window.location.hostname.toLowerCase().endsWith('.ie')
const gaId = isIE ? 'G-CT46K5CJXJ' : 'G-SKPFMZ4RJB'
Vue.use(VueGtag, {
  config: { id: gaId }
})

Vue.component('help-modal', HelpModal)
Vue.component('destination-modal', DestinationModal)
Vue.component('familyDisc-modal', FamilyDiscModal)
Vue.component('winterSports-modal', WinterSportsModal)
Vue.component('cruise-modal', CruiseModal)
Vue.component('car-modal', CarModal)
Vue.component('discount25-modal', Discount25Modal)
Vue.component('adventure-modal', AdventureModal)
Vue.component('groupIns-modal', GroupIns)
Vue.component('progress-bar', ProgessBar)
Vue.component('annual-policy-modal', AnnualPolicyModal)
Vue.component('backpacker-medical-modal', BackPackerMedicalModal)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
